// extracted by mini-css-extract-plugin
module.exports = {"root":"push-button_root__6OTjk","button":"push-button_button__kIzMp","background":"push-button_background__ARnk4"};